<div class="aspect-auto flex h-screen w-screen">
    <div class="left-section items-center">
        <div class="left-section-content">
            <div class="header text-4xl">
                {{'Forgot Password ?' | textCase}}
            </div>
            <div class="my-2 text-base mt-4">{{'No Worries , we\'ll send you reset instructions' | textCase}}</div>
            <div class="my-3">
                <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
                    <div class="p-fluid">
                        <div class="flex flex-col gap-2">
                            <label class="font-semibold" for="email">{{"Email" | textCase}}</label>
                            <input id="email" class="input" type="email" pInputText formControlName="email"
                                placeholder="{{'name@yourcompany.com' | textCase:CASE_TYPE.LOWER}}">
                            @if(resetForm.controls['email'].errors && resetForm.controls['email'].touched){
                            <div class="text-danger">
                                <small>
                                    @if(resetForm.controls['email'].errors['required']){
                                    *{{"Email is Required" | textCase}}
                                    } @else if(resetForm.controls['email'].errors['email']){
                                    *{{"Please enter a valid email address" | textCase}}
                                    }
                                </small>
                            </div>
                            }
                        </div>
                        <div class="mt-4">
                            <app-button variant="filled" severity="primary" label="{{'Reset Password' | textCase}}"
                                [disabled]="!resetForm.valid" (clicked)="onSubmit()" />
                        </div>
                    </div>
                </form>
            </div>
            <div class="flex items-center gap-4 justify-center w-[18.75rem] text-slate-600  mt-5 text-justify cursor-pointer hover:text-orange-500"
                [routerLink]="'/login'">
                <app-button icon="pi pi-arrow-left" iconPosition="left" variant="filled" severity="contrast"
                    label="Back to Login" (clicked)="redirect('/login')" />
            </div>
        </div>
    </div>
    <div class="right-section">
        <img class="login-image" [src]="'images/login-page.png' | assetUrl" alt="{{'login-image' | textCase}}">
    </div>
</div>
